import {DynamicTableProps} from '../components/dynamic-table';

export const getDynamicTable =
  <T>(data: Omit<DynamicTableProps<T>, 'type'>) =>
  (): DynamicTableProps<T> => ({
    ...data,
    type: 'dynamic-table',
  });
